export enum ApiTagsEnum {
  GET_GAME_ZONE_TEMPLATE = 'GET_GAME_ZONE_TEMPLATE',
  GET_USER_PROFILE = 'GET_USER_PROFILE',
}
